var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"font-size-24",attrs:{"href":"#"}},[_c('router-link',{attrs:{"to":"/log/models"}},[_c('a-icon',{directives:[{name:"add-class-hover",rawName:"v-add-class-hover",value:('text-primary'),expression:"'text-primary'"}],staticStyle:{"font-size":"22px"},attrs:{"type":"file-text"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }